 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT00_COVER from '@/components/Text/00_Cover'
 import TEXT01_HALFTITLE from '@/components/Text/01_Halftitle'
 import LOVE_1 from '@/components/love_1'
 import TEXT02_TITLE from '@/components/Text/02_Title'
 import TEXT03_COPYRIGHT from '@/components/Text/03_Copyright'
 import TEXT04_EPIGRAPH from '@/components/Text/04_Epigraph'
 import TEXT05_DEDICATION from '@/components/Text/05_Dedication'
 import TEXT06_CONTENTS from '@/components/Text/06_Contents'
 import TEXT07_ACKNOWLEDGEMENTS from '@/components/Text/07_Acknowledgements'
 import TEXT08_FOREWORD from '@/components/Text/08_Foreword'
 import TEXT09_CHAPTER01 from '@/components/Text/09_Chapter01'
 import TEXTSECTION0001 from '@/components/Text/Section0001'
 import TEXTSECTION0002 from '@/components/Text/Section0002'
 import TEXTSECTION0003 from '@/components/Text/Section0003'
 import TEXTSECTION0004 from '@/components/Text/Section0004'
 import TEXTSECTION0005 from '@/components/Text/Section0005'
 import TEXTSECTION0006 from '@/components/Text/Section0006'
 import TEXTSECTION0007 from '@/components/Text/Section0007'
 import TEXTSECTION0008 from '@/components/Text/Section0008'
 import TEXTSECTION0009 from '@/components/Text/Section0009'
 import TEXTSECTION0010 from '@/components/Text/Section0010'
 import TEXTSECTION0011 from '@/components/Text/Section0011'
 import TEXTSECTION0012 from '@/components/Text/Section0012'
 import TEXTSECTION0013 from '@/components/Text/Section0013'
 import TEXTSECTION0014 from '@/components/Text/Section0014'
 import TEXT10_CHAPTER02 from '@/components/Text/10_Chapter02'
 import TEXTSECTION0015 from '@/components/Text/Section0015'
 import TEXTSECTION0016 from '@/components/Text/Section0016'
 import TEXTSECTION0017 from '@/components/Text/Section0017'
 import TEXTSECTION0018 from '@/components/Text/Section0018'
 import TEXTSECTION0019 from '@/components/Text/Section0019'
 import TEXTSECTION0020 from '@/components/Text/Section0020'
 import TEXTSECTION0021 from '@/components/Text/Section0021'
 import TEXTSECTION0022 from '@/components/Text/Section0022'
 import TEXTSECTION0023 from '@/components/Text/Section0023'
 import TEXTSECTION0024 from '@/components/Text/Section0024'
 import TEXT11_CHAPTER03 from '@/components/Text/11_Chapter03'
 import TEXTSECTION0025 from '@/components/Text/Section0025'
 import TEXTSECTION0026 from '@/components/Text/Section0026'
 import TEXTSECTION0027 from '@/components/Text/Section0027'
 import TEXTSECTION0028 from '@/components/Text/Section0028'
 import TEXTSECTION0029 from '@/components/Text/Section0029'
 import TEXTSECTION0030 from '@/components/Text/Section0030'
 import TEXTSECTION0031 from '@/components/Text/Section0031'
 import TEXTSECTION0032 from '@/components/Text/Section0032'
 import TEXTSECTION0033 from '@/components/Text/Section0033'
 import TEXTSECTION0034 from '@/components/Text/Section0034'
 import TEXT12_CHAPTER04 from '@/components/Text/12_Chapter04'
 import TEXTSECTION0035 from '@/components/Text/Section0035'
 import TEXTSECTION0036 from '@/components/Text/Section0036'
 import TEXTSECTION0037 from '@/components/Text/Section0037'
 import TEXTSECTION0038 from '@/components/Text/Section0038'
 import TEXTSECTION0039 from '@/components/Text/Section0039'
 import TEXTSECTION0040 from '@/components/Text/Section0040'
 import LOVE_2 from '@/components/love_2'
 import TEXT13_BACKCOVER from '@/components/Text/13_Backcover'
 import NAV from '@/components/nav'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/06_Contents",
 			"name" : "Text/06_Contents",
 			"component" : TEXT06_CONTENTS
 		},
 		{
 			"path" : "/Text/07_Acknowledgements",
 			"name" : "Text/07_Acknowledgements",
 			"component" : TEXT07_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/Text/08_Foreword",
 			"name" : "Text/08_Foreword",
 			"component" : TEXT08_FOREWORD
 		},
 		{
 			"path" : "/Text/09_Chapter01",
 			"name" : "Text/09_Chapter01",
 			"component" : TEXT09_CHAPTER01
 		},
 		{
 			"path" : "/Text/Section0001",
 			"name" : "Text/Section0001",
 			"component" : TEXTSECTION0001
 		},
 		{
 			"path" : "/Text/Section0002",
 			"name" : "Text/Section0002",
 			"component" : TEXTSECTION0002
 		},
 		{
 			"path" : "/Text/Section0003",
 			"name" : "Text/Section0003",
 			"component" : TEXTSECTION0003
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js